<template>
  <div>
    <!-- ##### All Javascript Script ##### -->
    <!-- jQuery-2.2.4 js -->
    <script type="application/javascript" :src="'/js/jquery/jquery-2.2.4.min.js'"></script>
    <!-- Popper js -->
    <script type="application/javascript" :src="'/js/bootstrap/popper.min.js'"></script>
    <!-- Bootstrap js -->
    <script type="application/javascript" :src="'/js/bootstrap/bootstrap.min.js'"></script>
    <!-- All Plugins js -->
    <script type="application/javascript" :src="'/js/plugins/plugins.js'"></script>
    <script type="application/javascript" :src="'/js/plugins/audioplayer.js'"></script>
    <!-- Active js -->
    <script type="application/javascript" :src="'/js/active.js'"></script>
      
  </div>
</template>

<script>
export default {
  data(){
    return{
      date: new Date()
    }
  }
}
</script>

<style>

</style>